// extracted by mini-css-extract-plugin
export default {"container":"EntityActivities_container__mhRoM","children":"EntityActivities_children__zvAEm"};